module.exports = __webpack_public_path__ + "img/signature.ea4825f1.svg";